import { ACTION } from "../../util/utils";
import { OFFICE_REPLENISHMENT_PO_FETCH, KEYS, MODULE_KEY } from "./actions";

export const REDUCER_KEY = KEYS[MODULE_KEY + ACTION.STATE_KEY]

export interface IOfficeReplenishmentPOState {
    loading: boolean;
    error: any;
    data: []
}

const defaultState: IOfficeReplenishmentPOState = {
    loading: false,
    error: null,
    data: []
};

export const officeReplenishmentPOReducer = (
    state = defaultState,
    { type, payload }: any
) => {
    switch (type) {
        case OFFICE_REPLENISHMENT_PO_FETCH:
            return {
                ...state,
                loading: true,
            };
        case KEYS[MODULE_KEY + ACTION.SUCCESS]:
            return {
                ...state,
                loading: false,
                data: [...payload],
            };
        case KEYS[MODULE_KEY + ACTION.FAILED]:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        default:
            return state;
    }
};